import { render, staticRenderFns } from "./StudentProofDialog.vue?vue&type=template&id=6c61dfa2"
import script from "./StudentProofDialog.vue?vue&type=script&lang=js"
export * from "./StudentProofDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports